function About() {
  return (
    <>
      <p>Đang cập nhật!</p>
    </>
  )
}

export default About;
